import { NOT_MIX_REPORTING_TYPES } from '@/config/notMixReportingTypes';

export default function (locationTaxReportingType) {
  return NOT_MIX_REPORTING_TYPES.includes(locationTaxReportingType);
}
